var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.259277,
    y: 0.269348,
    width: 8.5375,
    height: 8.5375,
    fill: "url(#pattern0_1333_6794)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1333_6794",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1333_6794",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1333_6794",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFGklEQVR4nO2dS28cRRCAW0ogEhFBvF/hBESA+A3wF0BhecTr7R7vUrW707V5EQ5cFkWcEXBC8A9QuEGkXEE4kAcITkDIDcQBBYXYOBBIgsrroHV7N2sn3pma7vqklix77ameb6p7prunbYyiKIqiKIqSODOw70EH+R6H/j2H/pgFOuOAfrdIl7gsf83fQ3/MIb2boX/FdrsPlB13VAAcuMdhvteBP+WQrt5IsehPWPA9/ltl16eyuE7nkeVMAL90oyLWiqE/OXNaLdpZdv0qAwDcwhlhgRY2S8SaAn7JIr1JRNvKrq9oZjt7n7RI3429wsH/Y4E+c0iHG9h7nj+/p9O5kyVy4a8zpKf4Z/wZi/5z/p3riPnWgn+i7HqLpIH0okO/OPrk+Z8s0L56u33fRv9us9m7n3/Xgj87WjItZEgvTKdWFcUC5Rb85RFX8M8Z+HqtVttys8fo9/tbG+gbFuiXEZl32aHvbk5tIpAx5sp9f27u0O2bfbwZoh0O6IMxmZi2FG6mRmTGRdvuvTztYw+eZ+himCm2ne82KcIdcthnWKTzDeg+U1QM2av0LB8z7FNmW/kukxK1Wv/WNXdT4JeKlDEsJcwUh/4bvmszqeDAv7GmzyigmRqHRZoZ8XT/uknlCXzliXlVB152XBb9h0GWLM7N5Q+Z2BkMDA43VfQrANxRdlwzRDvCW2IL9LaJmSyje8OxKX7OMELIIM/CLJnN87tNrPATc3CbeZYf2IwQarXalsHw/Sop3sRKOITOgowwHNCBoEn9ykQ7uYR0ZXigkMeZjMw4/x2SciXKSa7w1pJHbY1QHNJ88Iz0kon+7grpsBGKA/9WcPG8Y2JjZZ57uEN/zgjFtvPdwcVz1MRGOB/BE0lGKHPt3tNBhpwxsWHRnxuuZLO5/y4jemEFDQ+j/GZiw6H/e7iSPMBohEJE24Lm9S8TG+HgnRGOq1i80VfQVSze6CvoKhZv9BV0FYs3+gq6isUbfQVdxeKNvoKuYvFGX0FXsXijr6CrWLzRV9BVLN7ltVU8vWnRfzl+kXRKxS868Md5aWzhw0K8PMaB/7r8k0Aii0U6zTOPxWWGyrg6UQz4U4WsfuRmquwr0FWkZECdqQsZ9BmrDvxJA/c/bBKn1aKdFvynwbmZn/qBw3f/9AXK8EXV4b7EXzDTJkzLqR+wYhR+flTI9VEhwlAhwlAhwlAhwlAhwlAhwlAhwlAhwlAhwlAhwlAhwlAhwkhWSL1+cDtvfzF4s5fn9P2iRTppwR8CgNvKiitJIc1u9zEL/sdxM3UW/PcNoEfLiC05IfX6we0O6YdJ06cspYxMSU6I5WZq/fParxUdX3JC3AY2VOYNlAuPLzkhuP5FeTz/X3x8qQkB/8f6M4TOFx5fgkKOb6APmS88vtSEZECd9TdZebvo+JIT0u/3t64nSyz6L8rYiys5IQzv8T5JCH/GlECSQphJQkxJqBBUISKvRKcZokJGoU0WaoaIaLIs+guSntBN6hlikT4e24cAHSkrrmSFzLbyXeEudSsPhOcc9h4vK65khTD89pZD+mh5wHG50JEyZZjUhUhEhQhDhQhDhQhDhQhDhQhDhQhDhQhDhQhDhQhDhQhDhQhDhQhDhaQuJJyp0w3MSt7ALNzij7e1UynmmoyjZWzxl09agqOFiltbvPLP6U/rSadJa4tPFLJN7P//nnQDbzKlVizSycI2Ur4G2+dXA3iVebhTaYrFAi0MzkXevpnM+A9+obIJaT9lZwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.93733a68393c6d0bc218e6507e6dbe75.svg";
export { ForwardRef as ReactComponent };